import cx from 'classnames'
import type { SwiperClass } from 'swiper/react'

import classNames from './styles.module.scss'


interface IProps {
  isEnd: boolean,
  isStart: boolean,
  slider?: SwiperClass,
  show: boolean,
}

export default function CarouselNavigation({
  isEnd,
  isStart,
  slider,
  show,
}: IProps): JSX.Element {
  return (
    <>
      <button
        className={cx(classNames.button, {
          [classNames.disabled]: isStart,
          [classNames.visible]: show,
        })}
        onClick={() => slider?.slidePrev()}
        data-test="btn-navigation-prev"
      />
      <button
        className={cx(classNames.button, {
          [classNames.disabled]: isEnd,
          [classNames.visible]: show,
        })}
        onClick={() => slider?.slideNext()}
        data-test="btn-navigation-next"
      />
    </>
  )
}
